import React from 'react';
import Draggable from 'react-draggable';

import CameraThumb from './CameraThumb';
import VideoPlayer from './VideoPlayer';
import BotaoFechar from './BotaoFechar';
import VideoTimeline from './VideoTimeline';

import { getCameraThumb } from '../util/camera';

import './CardCamera.css';

const CardCamera = ({ camera, camerasProximas, onClose, selecionaCamera, videoUrl, viajar, despublicar }) => (
  <Draggable>
  <div className="card card-camera">
    <div className="card-header">
      <div className="row">
        <div className="col col-lg-10">
          <h4 className="titulo mt-0">{`${ camera.name }`}</h4>
          <p className="descricao">{ camera.location }</p>
          <p className="localizacao">
            <a className="link-localizacao" onClick={ () => viajar(camera.coordenadas, 18) } >Ver localização</a>
          </p>
          <p className="localizacao">
            <a className="link-localizacao" onClick={ () => despublicar(camera) } >Remover</a>
          </p>
        </div>
        <div className="col col-lg-2 col-md-2">
          <BotaoFechar onClick={ onClose } />
        </div>
      </div>
    </div>

    <div className="video-area">
      <VideoPlayer id={`player_${new Date().getTime()}`}
           width="418"
           height="169"
           poster={ getCameraThumb(camera) }
           source={ videoUrl }
        />
    </div>

    <VideoTimeline camera={ camera } timeline={ camera.timeline } />

    <div className="card-block">
      <div className="row">
        <div className="col col-lg-10">
          <p className="cameras-proximas">Câmeras Próximas ({camerasProximas.length})</p>
        </div>
      </div>
      <div className="row thumb-row">
        { camerasProximas.map((c, i) => <CameraThumb camera={ c } selecionaCamera={ selecionaCamera } key={ i } />) }
      </div>
    </div>
  </div>
  </Draggable>
);

export default CardCamera;



// WEBPACK FOOTER //
// ./src/components/CardCamera.js